export const haafPaymentKeys = {
  all: ["haafPayments"],
  lists: () => [...haafPaymentKeys.all, "list"],
  list: (financialYearId) => [
    ...haafPaymentKeys.lists(),
    { financialYearId },
  ],
  chapterList: (financialYearId) => [
    ...haafPaymentKeys.lists(),
    "chapter",
    { financialYearId },
  ],
  batchList: (batch, financialYearId) => [
    ...haafPaymentKeys.lists(),
    "batch",
    batch,
    { financialYearId },
  ],
  stats: (financialYearId) => [
    ...haafPaymentKeys.lists(),
    "stats",
    { financialYearId },
  ],
  batchStats: (financialYearId) => [
    ...haafPaymentKeys.lists(),
    "batchStats",
    { financialYearId },
  ],
  chapterStats: (financialYearId) => [
    ...haafPaymentKeys.lists(),
    "chapterStats",
    { financialYearId },
  ],
  statistics: () => [...haafPaymentKeys.all, "statistics"],
  statisticsOverview: (financialYearId) => [
    ...haafPaymentKeys.statistics(),
    "overview",
    { financialYearId },
  ],
  statisticsTimeseries: (financialYearId, interval) => [
    ...haafPaymentKeys.statistics(),
    "timeseries",
    { financialYearId, interval },
  ],
  statisticsBreakdown: (financialYearId, groupBy) => [
    ...haafPaymentKeys.statistics(),
    "breakdown",
    { financialYearId, groupBy },
  ],
  statisticsLeaderboard: (financialYearId, groupBy, limit) => [
    ...haafPaymentKeys.statistics(),
    "leaderboard",
    { financialYearId, groupBy, limit },
  ],
  statisticsPending: (financialYearId) => [
    ...haafPaymentKeys.statistics(),
    "pending",
    { financialYearId },
  ],
  statisticsRecentActivity: (financialYearId, limit) => [
    ...haafPaymentKeys.statistics(),
    "recentActivity",
    { financialYearId, limit },
  ],
  statisticsAlumniCoverage: (financialYearId) => [
    ...haafPaymentKeys.statistics(),
    "alumniCoverage",
    { financialYearId },
  ],
  statisticsComparison: (financialYearId, compareWith) => [
    ...haafPaymentKeys.statistics(),
    "comparison",
    { financialYearId, compareWith },
  ],
  meta: () => [...haafPaymentKeys.all, "meta"],
  filterOptions: () => [...haafPaymentKeys.all, "filterOptions"],
  financialYears: () => [...haafPaymentKeys.all, "financialYears"],
  alumniSearch: (search) => [...haafPaymentKeys.all, "alumni", search],
  details: () => [...haafPaymentKeys.all, "detail"],
  detail: (id) => [...haafPaymentKeys.details(), id],
};
